import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as e } from "../mixins/widget.js";
import { connectVoiceSearch as i } from "instantsearch.js/es/connectors/index.js";
export default {
  name: "AisVoiceSearch",
  mixins: [e({
    connector: i
  }, {
    $$widgetType: "ais.voiceSearch"
  }), t({
    name: "VoiceSearch"
  })],
  props: {
    searchAsYouSpeak: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    language: {
      type: String,
      default: void 0
    },
    additionalQueryParameters: {
      type: Object,
      default: void 0
    },
    buttonTitle: {
      type: String,
      required: !1,
      default: "Search by voice"
    },
    disabledButtonTitle: {
      type: String,
      required: !1,
      default: "Search by voice (not supported on this browser)"
    }
  },
  data: function data() {
    return {
      buttonSvgAttrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    };
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        searchAsYouSpeak: this.searchAsYouSpeak,
        language: this.language,
        additionalQueryParameters: this.additionalQueryParameters
      };
    },
    errorNotAllowed: function errorNotAllowed() {
      return "error" === this.state.voiceListeningState.status && "not-allowed" === this.state.voiceListeningState.errorCode;
    },
    rootSlotProps: function rootSlotProps() {
      return {
        isBrowserSupported: this.state.isBrowserSupported,
        isListening: this.state.isListening,
        toggleListening: this.state.toggleListening,
        voiceListeningState: this.state.voiceListeningState
      };
    },
    innerSlotProps: function innerSlotProps() {
      return {
        status: this.state.voiceListeningState.status,
        errorCode: this.state.voiceListeningState.errorCode,
        isListening: this.state.isListening,
        transcript: this.state.voiceListeningState.transcript,
        isSpeechFinal: this.state.voiceListeningState.isSpeechFinal,
        isBrowserSupported: this.state.isBrowserSupported
      };
    }
  },
  methods: {
    handleClick: function handleClick(t) {
      t.currentTarget.blur(), this.state.toggleListening();
    }
  }
};